import {totalTitle, formatter} from '@/components/data'

export const getCountConfig = (num) => {
  return {
    number: [num || 0],
    content: '{nt}',
    textAlign: 'left',
    style: {
      fill: '#ffe',
      fontWeight: 'bold',
      fontSize: 30
    }
  }
}
export const getTotal = (total, flag) => {
  const config = []
  totalTitle.forEach(item => {
    const num = Number(total[item.name])
    const arr = num.toString().split('.')
    const fixed = arr[1] ? 2 : 0
    config.push({
      title: flag ? item.other : item.title,
      number: {
        number: formatter(num, fixed),
        total: num,
        content: '{nt}',
        textAlign: 'center',
        toFixed: fixed,
        style: {
          color: item.color,
          fontWeight: 'bold',
          fontSize: 80
        },
        formatter
      },
      width: item.width,
      unit: item.name === 'amount' ? '￥' : ''
    })
  })
  return config
}
export const getOrderConfig = (orders) => {
  const rate = document.body.clientWidth > 2000 ? 0 : 23.5
  const config = {
    header: ['时间', '订单编号', '金额', '用户'],
    data: [],
    columnWidth: [210, 225 - rate / 2, 110 - rate, 210 + rate],
    align: ['center'],
    rowNum: 9,
    headerBGC: '#1981f6',
    headerHeight: 45,
    oddRowBGC: 'rgba(0, 44, 81, 0.8)',
    evenRowBGC: 'rgba(10, 29, 50, 0.8)'
  }
  const data = []
  orders.forEach(item => {
    if (Number(item.amount)) {
      data.push([item.date, item.order_id, item.amount, item.mail])
    }
  })
  config.data = data
  return config
}
export const getPackageConfig = (orders) => {
  const rate = document.body.clientWidth > 2000 ? 0 : 23.5
  const config = {
    header: ['时间', '国际物流单号', '国家', '用户'],
    data: [],
    columnWidth: [210, 225 - rate / 2, 110 - rate, 210 + rate],
    align: ['center'],
    rowNum: 9,
    headerBGC: '#1981f6',
    headerHeight: 45,
    oddRowBGC: 'rgba(0, 44, 81, 0.8)',
    evenRowBGC: 'rgba(10, 29, 50, 0.8)'
  }
  const data = []
  orders.forEach(item => {
    data.push([item.date, item.shipped_number, item.country, item.mail])
  })
  config.data = data
  return config
}
